webpackJsonp([58271333782643],{

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.ProjektPostTemplate = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(31);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Content = __webpack_require__(25);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _SiteConfig = __webpack_require__(20);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _seo = __webpack_require__(26);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjektPostTemplate = exports.ProjektPostTemplate = function ProjektPostTemplate(_ref) {
	  var content = _ref.content,
	      contentComponent = _ref.contentComponent,
	      description = _ref.description,
	      title = _ref.title,
	      thumbnail = _ref.thumbnail,
	      slug = _ref.slug,
	      postNode = _ref.postNode;
	
	  var PostContent = contentComponent || _Content2.default;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: title + ' | ' + _SiteConfig2.default.siteTitle }),
	    _react2.default.createElement(_seo2.default, { postPath: slug, postNode: postNode, postSEO: true }),
	    _react2.default.createElement('section', {
	      className: 'hero is-medium ', style: {
	        background: "url(" + thumbnail + ")",
	        backgroundSize: "cover",
	        backgroundPosition: "bottom",
	        minHeight: "40vh"
	      } }),
	    _react2.default.createElement(
	      'section',
	      { className: 'section' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column' },
	            _react2.default.createElement(
	              'div',
	              { className: 'fun' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                title
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'container content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-10 is-offset-1' },
	            _react2.default.createElement(
	              'p',
	              null,
	              description
	            ),
	            _react2.default.createElement(PostContent, { content: content, className: 'projekt' }),
	            _react2.default.createElement('div', { className: 'separtor asfaltbackground' }),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/' },
	              _react2.default.createElement(
	                'button',
	                null,
	                'Wroc'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	ProjektPostTemplate.propTypes = {
	  content: _propTypes2.default.string.isRequired,
	  contentComponent: _propTypes2.default.func,
	  description: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  helmet: _propTypes2.default.instanceOf(_reactHelmet2.default)
	};
	
	var ProjektPost = function ProjektPost(_ref2) {
	  var data = _ref2.data;
	  var post = data.markdownRemark;
	
	
	  return _react2.default.createElement(ProjektPostTemplate, {
	    content: post.html,
	    contentComponent: _Content.HTMLContent,
	    description: post.frontmatter.description,
	    tags: post.frontmatter.tags,
	    title: post.frontmatter.title,
	    slug: post.fields.slug,
	    thumbnail: post.frontmatter.thumbnail,
	    date: post.frontmatter.date,
	    postNode: post,
	    postPath: post.fields.slug
	  });
	};
	
	ProjektPost.propTypes = {
	  data: _propTypes2.default.shape({
	    markdownRemark: _propTypes2.default.object
	  })
	};
	
	exports.default = ProjektPost;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-projekt-post-js-1d5157c06aa89aabb9ad.js